import { getEventTargetInstance } from '@cimpress-technology/authfront-sdk-core'
import { transformAuthIdentityEventToUserIdentityEvent } from './helper'
import { EMPTY_IDENTITY } from '../../common/constants'

export function onUserIdentityUpdate (callback: (result?: any) => void): void {
  const eventTargetInstance = getEventTargetInstance()
  eventTargetInstance.addEventListener('userIdentity', (e: any) => {
    const userDetails = e.detail
    const identity = transformAuthIdentityEventToUserIdentityEvent(userDetails)
    callback(identity)
  })
  eventTargetInstance.addEventListener('completeCallbackEvent', () => {
    callback(EMPTY_IDENTITY)
  })
}
